import { render, staticRenderFns } from "./baoyang.vue?vue&type=template&id=74dc1c4c&scoped=true"
import script from "./baoyang.vue?vue&type=script&lang=js"
export * from "./baoyang.vue?vue&type=script&lang=js"
import style0 from "./baoyang.vue?vue&type=style&index=0&id=74dc1c4c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc1c4c",
  null
  
)

export default component.exports